import axios from 'axios';
import { Message } from 'element-ui'

const BIND_WX_URL = '/front/user/bind/wx/'

function isBindWxRequest(config) {
    const url = config?.url || ''
    return url.includes(BIND_WX_URL)
}

const baseURL = API_SERVER
const appid = APP_ID
const instance = axios.create({
    //基地址
    baseURL,
    //超时时间
    timeout: 30000,
    //  headers: {
    // 'Content-Type': 'application/json;charset=utf-8',
    //  }
})

//请求拦截器
instance.interceptors.request.use(
    (config) => {
        if (!config.url.startsWith("http")) {
            if (config.url.startsWith("/wap/")) {
                config.url = baseURL + config.url;
            } else {
                config.url = baseURL + "/api" + config.url;
            }
        }
        let token = localStorage.getItem('token')
        config.appid = appid
        config.headers['h5token'] = token;
        // console.log("config=", config)
        return config
    },
    (err) => Promise.reject(err)
)

//响应拦截
instance.interceptors.response.use(res => {
    // 成功
    // console.log('成功')
    if (res.status == 200) {
        return res.data

    }
    if (isBindWxRequest(res.config) && res.status === 401) {
        return res.data
    }
    return Promise.reject(res)

}, err => {
    console.log('失败')
    if (err.response && isBindWxRequest(err.config)) {
        if (err.response.status === 401) {
            return err.response.data
        }
        const data = err.response.data
        if (data?.status === '401' || data?.status === 401) {
            return data
        }
    }
    if (err.status == 401 && err.message) {
        // console.log('服务器内部错误1', err)
        // this.$message.error('请重新登录');
        // Message.error('请重新登录')
        // userStore().setLoginBox(true)
    } else if (err.status == 500) {
        // console.log('服务器内部错误2', err)
        // Message.error('服务器繁忙，请稍后重试')
    }

    return Promise.reject(err);
}
)

export default instance